export default "__VITE_ASSET__DUnw8Emt__"